(function() {

  function restrictWSHCountry() {
    const countrySelect = document.getElementById('wpdAddressCountry');

    if (!countrySelect) return false;

    countrySelect.value = 'United States';

    Array.from(countrySelect.options).forEach(function(option) {
      option.disabled = option.value !== 'United States';
    });

    countrySelect.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    countrySelect.style.pointerEvents = 'none';

    return true;
  }

  if (restrictWSHCountry()) return;

  const observer = new MutationObserver(function() {
    if (restrictWSHCountry()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();